const STYLES = {
  openai: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
  elevenlabs: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-300',
  heygen: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300',
  liveavatar: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
};

export default function ProviderBadge({ provider, label }) {
  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${
        STYLES[provider] || 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200'
      }`}
    >
      {label || provider}
    </span>
  );
}
